import { createRef, useEffect, useMemo, useState } from "react"
import { BaseMenuClick } from "../../../../../../../components/baseMenu"
import { useLogbookContext } from "../../../context"
import { ActivityMap } from "../../shared"
import { Box, Button, Grid, IconButtonProps, Pagination, SxProps, Typography } from "@mui/material"
import { UserActivityState } from "../../activityRegister/mapLeft/types"
import { FloatFilter } from "../../../../../../../components/filtersDrawer/floatFilter"
import { returnQuery } from "../../../../../../../utils/methods/returnQuery"
import { useTimeOut } from "../../../../../../../hooks/timeOut"
import { menuOptions } from "../../activityRegister/mapLeft/menuOptions"
import { DeleteActivity, SeeReport } from "../../activityRegister/utils/types"
import { SnackbarTypes, Types } from "../../../../../../../utils/enums/types"
import { useTranslation } from "react-i18next"
import { ModalType } from "../../../../../../../utils/types/generals"
import { CodeDeleteActivity, CodeFinishActivity, CodeStartActivity, LogbookUser } from "../../../../../../../service/logbook/response"
import SimpleModal from "../../../../../../../components/modal/simpleModal"
import { SnackSimple } from "../../../../../../../components"
import { loogbookServiceFetch } from "../../../../../../../utils/constants/callService"
import { MyActivityList } from "../../activityRegister/myActivityList"
import { useStyles } from "./styles"
import { UserMarkMap } from "../../shared/map/types"
import { CustomPaper } from "../../../../../../../components/CustomPaper"
import { CustomeIconButton } from "../../../../../../../components/customeIconButton"
import { icons } from "../../../../../../../utils/icons"
import { CancelActivityRef } from "../../shared/detail/components/cancelActivity/types"
import { ReScheduleActivityRef } from "../../shared/detail/components/reSchedule/types"
import { ResendActivityRef } from "../../shared/detail/components/resend/types"
import { CancelActivity } from "../../shared/detail/components/cancelActivity"
import dayjs from "dayjs"
import { TimeZoneGneral } from "../../shared/detail/types"
import { ReScheduleActivity } from "../../shared/detail/components/reSchedule"
import { toUnitTimeZone } from "../../../../../../../utils/methods/calcDate"
import { Constants } from "../../../../../../../utils/constants"
import { handleAllErrors } from "../../../../../../../utils/methods/handleErrors"
import { RequestErrors, Status } from "../../../../../../../utils/enums"
import { CodeResendActivity } from "../../../../../../../service/logbook/response/resendActivity"
import { ResendActivity } from "../../shared/detail/components/resend"
import { getLocalStorage, LocaleNameType } from "../../../../../../../utils/crud/crypt"
import useGeolocation from "../../../../../../../hooks/localization"
import { geoDistanceInMeters } from "../../../../../../../utils/methods/calcDistanceFromLatAndLong"
import { FinishActivityBody, StartActivityBody } from "../../../../../../../service/logbook/body"
import { ConfirmActivityAction } from "../../shared/detail/utils/enums"
import { ForceClosureActivity } from "../../shared/detail/components/forceClosure"
import { PointType } from "../../../utils/enums/pointType"
import { ChildrenCoordinates } from "../../shared/activityOnMap/types"

export const ActivityList = () => {
    const { executeFunction } = useTimeOut()
    const { t } = useTranslation()
    const [snackbar, setSnackbar] = useState({ open: false, message: '', type: SnackbarTypes.SUCCESS as string, })
    const [modal, setModal] = useState<ModalType>({ open: false, description: '', title: '' })
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)
    const [types, setTypes] = useState<{ count: number; type: Status; }[]>([])
    const [totalItems, setTotalItems] = useState(0)
    const styles = useStyles()
    const { state: { myActivity }, loadingActivities, service, filter: { filterMyActivity }, visibleUsersData, setVisibleUsersData } = useLogbookContext()
    const filterUser = filterMyActivity.filter
    const input = filterMyActivity.input
    const [hiddenLocal, setHiddenLocale] = useState<string[]>([])
    const [hiddenLocalCopy, setHidenLocalCopy] = useState<string[]>([])
    const visibleUsersList = Object.values(visibleUsersData);
    const [data, SetData] = useState<{
        data: LogbookUser | undefined;
        total: number | undefined;
        transform: UserActivityState & {
            userMark: UserMarkMap[];
        };
    }>()
    const cancelRef = createRef<CancelActivityRef>()
    const reAcheduleRef = createRef<ReScheduleActivityRef>()
    const resendRef = createRef<ResendActivityRef>()
    const branding = getLocalStorage<any>(LocaleNameType.SETTING)
    const { location: geoLocation } = useGeolocation()
    const [localLoad, setLocalLoad] = useState(false)
    const local = getLocalStorage<any>()
    const [isPagintaion, setIsPagination] = useState(true)
    const [expandMap, setExpandMap] = useState(true)
    const [oldFilterString, setOldFilterString] = useState('')
    const displayHidden = ({ id }: { id: string }) => {
        setHiddenLocale(prev => {
            const existUser = prev.some(userId => userId == id)
            return existUser ? prev.filter(userId => userId != id) : [...prev, id]
        })
    }
    const goToActivityDetail: BaseMenuClick = (item, payload) => {
        menuOptions({ item, payload: { ...payload, deleteActivity, seeReport, cancelActivity, finishActivity: confirmActiveOrFinish, forcedFinish: forceClosureActivity, reScheduleActivity, resend: resendActivity, startActivity: confirmActiveOrFinish }, })
    }

    const loadingModal = (value: boolean) => {
        setModal(prev => ({ ...prev, loading: value }))
    }

    const deleteActivity: DeleteActivity = ({ id }) => {
        setModal(prev => ({
            ...prev,
            open: true,
            description: t('loogbook.modal.deleteActivity'),
            title: t('general.confirm'),
            confirm: async () => {
                const [_, activityId] = id.split('-') ?? []
                setModal(prev => ({ ...prev, loading: true }))
                const response = await service.deleteActivity({ id: id })
                setModal(prev => ({ ...prev, loading: false }))
                if (response.code == CodeDeleteActivity.SUCCESS) {
                    myActivities()
                    closeModal()
                    setSnackbar({ message: t('loogbook.snackbar.deleteActivity.success'), open: true, type: SnackbarTypes.SUCCESS })
                    return
                }
                setSnackbar({ message: t('loogbook.snackbar.deleteActivity.error'), open: true, type: SnackbarTypes.ERROR })
            },
            cancel: closeModal
        }))
    }
    const seeReport: SeeReport = async ({ id }) => {
        setSnackbar({ message: t('loogbook.snackbar.loadingReport'), open: true, type: Types.INFO })
        const response = await loogbookServiceFetch.seeInform({ id: Number(id) })

        if (response.errors) {
            setSnackbar({ message: t('loogbook.snackbar.seeInform.error'), open: true, type: Types.ERROR })
        } else {
            window.open(response.reportUrl, '_blank');
        }

    }

    const confirmCancel = async ({ id }: { id: string }) => {
        if (cancelRef.current) {
            const reason = cancelRef.current?.getData?.reason?.trim()
            cancelRef.current.loading(true)
            if (!!reason) {
                const response = await loogbookServiceFetch.cancelActivities({ id: id, body: { closeMotive: reason, } })
                cancelRef.current.loading(false)
                if (response.code == CodeDeleteActivity.SUCCESS) {
                    myActivities()
                    closeModal()
                    setSnackbar({ message: t('loogbook.snackbar.cancelActivity.success'), open: true, type: Types.SUCCESS })
                    return
                }
                setSnackbar({ message: t('loogbook.snackbar.cancelActivity.error'), open: true, type: Types.ERROR })
            }
        }
    }
    const cancelActivity = async ({ id }: { id: string }) => {
        setModal(prev => ({
            ...prev,
            open: true,
            removeButtons: true,
            children:
                <CancelActivity
                    cancel={closeModal}
                    confirm={() => { confirmCancel({ id }) }}
                    ref={cancelRef}
                />,
            description: t('general.cancelReason'),
            sx: styles.cancelStyles,
            title: t('general.cancelActivity'),
            confirmText: t('general.cancelActivity'),
        }))
    }
    const reScheduleActivity = async ({ id, timeZone, startDate, endDate }: { id: string; timeZone: TimeZoneGneral; startDate: dayjs.Dayjs | null; endDate: dayjs.Dayjs | null }) => {
        const isValidatedStartDate = dayjs().isAfter(startDate)
        const isValidatedEndDate = dayjs().isAfter(endDate)
        const dateStart = startDate ? dayjs(startDate) : dayjs()
        const dateEnd = endDate ? dayjs(endDate) : null
        setModal(prev => ({
            ...prev,
            open: true,
            removeButtons: true,
            children:
                <ReScheduleActivity
                    timeZone={timeZone}
                    defaultDate={{
                        from: isValidatedStartDate ? dayjs(toUnitTimeZone(new Date(), timeZone.value)) : dateStart,
                        to: isValidatedEndDate ? null : dateEnd,
                    }}
                    cancel={closeModal}
                    confirm={() => { confirmReSchedule({ id, timeZone }) }}
                    ref={reAcheduleRef}
                />,
            description: '',
            sx: styles.cancelStyles,
            title: t('loogbook.reScheduleActivity'),
            confirmText: t('general.reSchedule'),
        }))
    }
    const confirmReSchedule = async ({ id, timeZone }: { id: string; timeZone: TimeZoneGneral; }) => {
        if (reAcheduleRef.current) {
            const dates = reAcheduleRef.current?.getData
            reAcheduleRef.current.loading(true)
            if (!!dates) {
                const response = await loogbookServiceFetch.reScheduleActivities({
                    id: id,
                    body: {
                        dateEnd: dayjs(dates.to).format(Constants.dayjsFormat3),
                        dateStart: dayjs(dates.from).format(Constants.dayjsFormat3),
                        ...(!!timeZone?.id) && { timeZone: timeZone?.id },
                    }
                })
                reAcheduleRef.current.loading(false)
                if (response.code == CodeDeleteActivity.SUCCESS) {
                    myActivities()
                    closeModal()
                    setSnackbar({ message: t('loogbook.snackbar.reScheduleActivity.success'), open: true, type: Types.SUCCESS })
                    return
                }
                setSnackbar({ message: handleAllErrors(response.errors?.[0]?.code ?? RequestErrors.ERR_AUTH, t), open: true, type: Types.ERROR })
            }
        }
    }
    const confirmResend = async ({ id }: { id: string }) => {
        if (resendRef.current) {
            const resendData = resendRef.current?.getData
            resendRef.current.loading(true)
            if (!!resendData) {
                const response = await loogbookServiceFetch.resendActivities({
                    body: {
                        external_emails: resendData.emails?.split(',').filter(email => !!email).map(email => email.trim()) ?? [],
                        user_ids: resendData.usersIds ?? [],
                        id: id,
                    }
                })
                resendRef.current.loading(false)
                if (response.code == CodeResendActivity.SUCCESS) {
                    closeModal()
                    setSnackbar({ message: t('loogbook.snackbar.resendActivity.success'), open: true, type: Types.SUCCESS })
                    return
                }
                setSnackbar({ message: t('loogbook.snackbar.resendActivity.error'), open: true, type: Types.ERROR })
            }
        }
    }
    const resendActivity = async ({ id, timeZone }: { id: string; timeZone: TimeZoneGneral; }) => {
        setModal(prev => ({
            ...prev,
            open: true,
            removeButtons: true,
            children:
                <ResendActivity
                    timeZone={timeZone}
                    cancel={closeModal}
                    confirm={() => { confirmResend({ id }) }}
                    ref={resendRef}
                />,
            description: '',
            sx: styles.cancelStyles,
            title: t('general.resendReport'),
            confirmText: t('general.reSchedule'),
        }))
    }
    const isIntoTheRange = ({ geofence, storePoint }: { geofence: boolean; storePoint: { lat: string; lng: string; locationInitSiteName: string; } }) => {
        const fence: number = branding?.brandy?.configLocations?.digitalFenceMts ?? 0

        if (!geofence || !fence) {
            return { intoRange: true }
        }

        const userLat = geoLocation.lat?.toString() ?? ''
        const userLng = geoLocation.lng?.toString() ?? ''
        if (storePoint) {
            const meters = Math.abs(Number(geoDistanceInMeters({ from: { lat: userLat, lng: userLng }, to: { lat: storePoint.lat, lng: storePoint.lng } })) ?? 0)
            const intoRange = fence >= meters
            if (!intoRange) {
                setSnackbar({ open: true, message: t('loogbook.snackbar.range.youAreOutside'), type: Types.ERROR })
            }
            return { intoRange }
        }

        setSnackbar({ open: true, message: t('loogbook.snackbar.range.thereNoRange'), type: Types.ERROR })
        return { intoRange: true, thereNoLocation: true }
    }
    const startActivity = async ({ id, initDate, geofence, storePoint }: { id: string, initDate: dayjs.Dayjs | null, geofence: boolean; storePoint: { lat: string, lng: string; locationInitSiteName: string; } }) => {
        const startDate = dayjs.utc(initDate).format(Constants.dayjsFormat3)
        const validateDate = initDate ? dayjs().isBefore(dayjs(startDate), 'seconds') : false
        if (validateDate) {
            setSnackbar({ open: true, message: t('loogbook.snackbar.startActivity.pastDate'), type: Types.ERROR })
            return
        }
        loadingModal(true)
        const userLat = geoLocation.lat?.toString() ?? ''
        const userLng = geoLocation.lng?.toString() ?? ''
        const body: StartActivityBody = {
            isMobile: false,
            latitude: userLat,
            longitude: userLng
        }
        const validateRange = isIntoTheRange({ geofence, storePoint })
        if (validateRange.intoRange) {
            const response = await loogbookServiceFetch.startActivity({ id: id, body })
            loadingModal(false)
            if (response.code == CodeStartActivity.SUCCESS) {
                myActivities()
                setSnackbar({ open: true, message: t('loogbook.snackbar.startActivity.success'), type: Types.SUCCESS })
                closeModal()
                return
            }
            setSnackbar({ open: true, message: handleAllErrors(response?.errors?.[0]?.code, t, 'loogbook.snackbar.startActivity.error'), type: Types.ERROR })
            return
        } else {
            loadingModal(false)
            setSnackbar({ open: true, message: t('loogbook.modal.startActivityOutRange'), type: Types.ERROR })
        }
    }
    const finishActivity = async ({ id, geofence, storePoint, someIsRequired }: { id: string, geofence: boolean; storePoint: { lat: string; lng: string; locationInitSiteName: string; }, someIsRequired: boolean }) => {

        if (someIsRequired) {
            //evidenceUpload.setShowRequireds(true)
            setSnackbar({ message: t('loogbook.snackbar.requiredFields'), open: true, type: Types.ERROR })
            closeModal()
            return
        }
        loadingModal(true)
        const body: FinishActivityBody = {
            isMobile: false,
            latitude: geoLocation.lat?.toString() ?? '',
            longitude: geoLocation.lng?.toString() ?? ''
        }
        const validateRange = isIntoTheRange({ geofence, storePoint })
        if (validateRange.intoRange) {
            const response = await loogbookServiceFetch.finsihActivity({ id: id, body })
            loadingModal(false)
            if (response.code == CodeFinishActivity.SUCCESS) {
                myActivities()
                setSnackbar({ open: true, message: t('loogbook.snackbar.finishActivity.success'), type: Types.SUCCESS })
                closeModal()
                return
            }
            setSnackbar({ open: true, message: handleAllErrors(response?.errors?.[0]?.code, t, 'loogbook.snackbar.finishActivity.error'), type: Types.ERROR })
        } else {
            loadingModal(false)
            setSnackbar({ open: true, message: t('loogbook.modal.finishActivityOutRange'), type: Types.ERROR })
        }
    }
    const confirmActiveOrFinish = ({ action, geofence, id, initDate, someIsRequired, storePoint }: { action: ConfirmActivityAction, id: string, initDate: dayjs.Dayjs | null, geofence: boolean; storePoint: { lat: string, lng: string; locationInitSiteName: string; }, someIsRequired: boolean }) => {
        let title = ''
        let confirm = () => { }
        switch (action) {
            case ConfirmActivityAction.START: {
                title = t('loogbook.modal.start.title')
                confirm = () => { startActivity({ geofence, id, initDate, storePoint }) }
                break
            }
            case ConfirmActivityAction.FINISH: {
                title = t('loogbook.modal.finish.title')
                confirm = () => { finishActivity({ geofence, id, someIsRequired, storePoint }) }
                break
            }
        }
        setModal(prev => ({
            ...prev,
            open: true,
            title: title,
            confirm,
            cancel: closeModal
        }))
    }
    const forceClosureActivity = async ({ geofence, id, storePoint }: { id: string, geofence: boolean; storePoint: { lat: string; lng: string; locationInitSiteName: string; } }) => {
        setModal(prev => ({
            ...prev,
            open: true,
            removeButtons: true,
            children:
                <ForceClosureActivity
                    cancel={closeModal}
                    confirm={() => { confirmForcingClose({ id, storePoint }) }}
                    ref={cancelRef}
                />,
            description: isIntoTheRange({ geofence, storePoint }).intoRange ? t('general.forcingDescriptionIntoRange') : t('general.forcingDescriptionOutRange'),
            sx: styles.cancelStyles,
            title: t('general.forcingClosure'),
            confirmText: t('general.cancelActivity'),
        }))
    }
    const confirmForcingClose = async ({ id, storePoint }: { id: string, storePoint: { lat: string; lng: string; locationInitSiteName: string; } }) => {
        if (cancelRef.current) {
            const reason = cancelRef.current?.getData?.reason?.trim()
            cancelRef.current.loading(true)
            if (!!reason) {
                const userLat = geoLocation.lat?.toString() ?? ''
                const userLng = geoLocation.lng?.toString() ?? ''
                const response = await loogbookServiceFetch.forceActivities({
                    id: id, body: {
                        closeMotive: reason,
                        isMobile: false,
                        latitude: userLat,
                        longitude: userLng,
                        locationInitSiteName: storePoint?.locationInitSiteName ?? ''
                    }
                })
                cancelRef.current.loading(false)
                if (response.code == CodeDeleteActivity.SUCCESS) {
                    myActivities()
                    closeModal()
                    setSnackbar({ message: t('loogbook.snackbar.forceActivity.success'), open: true, type: Types.SUCCESS })
                    return
                }
                setSnackbar({ message: t('loogbook.snackbar.forceActivity.error'), open: true, type: Types.ERROR })
            }
        }
    }
    const changePagination = (page: number) => {
        filterUser.handlePagination({ page, pageSize: 20 })
    }

    const seeAll = () => {
        setHiddenLocale([])
    }

    const hiddenAll = () => {
        setHiddenLocale(hiddenLocalCopy)
    }

    useEffect(() => {
        if (myActivity?.usersMark?.length) {
            setVisibleUsersData((prev) => {
                const updatedUsersData = { ...prev };

                // Filtra los usuarios que deben permanecer visibles
                const newVisibleUsers = myActivity.usersMark.filter(
                    (userMark) => !hiddenLocal.includes(userMark.user.id)
                );

                // Añade los usuarios no ocultos
                newVisibleUsers.forEach((userMark) => {
                    if (!updatedUsersData[userMark.user.id]) {
                        updatedUsersData[userMark.user.id] = userMark;
                    }
                });

                // Elimina los usuarios que están en hiddenLocal
                hiddenLocal.forEach((userId) => {
                    if (updatedUsersData[userId]) {
                        delete updatedUsersData[userId];
                    }
                });

                return updatedUsersData;
            });
        }
    }, [myActivity.usersMark, hiddenLocal]);

    useEffect(() => {
        if (myActivity?.usersMark?.length) {
            if (isPagintaion) {
                const newVisibleUsers = myActivity.usersMark.filter((userMark) => {
                    return !hiddenLocal.includes(userMark.user.id);
                });

                setVisibleUsersData((prev) => {
                    const updated = { ...prev };
                    newVisibleUsers.forEach((userMark) => {
                        if (!updated[userMark.user.id]) {
                            updated[userMark.user.id] = { ...userMark }; // copia sin mutar original
                        }
                    });

                    // También eliminamos los ocultos
                    hiddenLocal.forEach((userId) => {
                        delete updated[userId];
                    });

                    return updated;
                });
            } else {
                const hiddenIds = new Set(hiddenLocal);

                setVisibleUsersData(() => {
                    const updated: Record<string, typeof myActivity.usersMark[0]> = {};

                    myActivity.usersMark.forEach((userMark) => {
                        const userId = userMark.user.id;
                        if (!hiddenIds.has(userId)) {
                            updated[userId] = { ...userMark }; // copia segura
                        }
                    });

                    return updated;
                });
            }

        }
    }, [myActivity.usersMark, hiddenLocal]);

    // Paso 2: Una vez actualizado visibleUsersDataGeneralList, asignar los índices
    useEffect(() => {
        const countByCoordinates: Record<string, number> = {};
        const childrenByCoordinates: Record<string, ChildrenCoordinates[]> = {};

        for (const key in visibleUsersData) {
            const pointArray = visibleUsersData[key].points;
            for (const point of pointArray) {
                if (point.isUnity) {
                    const coordKey = `${point.lat},${point.lng}`;
                    countByCoordinates[coordKey] = (countByCoordinates[coordKey] || 0) + 1;
                    if (!childrenByCoordinates[coordKey]) {
                        childrenByCoordinates[coordKey] = [];
                    }

                    childrenByCoordinates[coordKey].push(
                        {
                            endDate: point.endProgramed,
                            endExecution: point.endDate,
                            isForcedClosure: point.isForceClose,
                            startDate: point.startProgramed,
                            startExecution: point.startDate,
                            status: point.status,
                            title: point.title,
                            typeProgramation: point.typeActivity,
                            userAssigned: point.userName
                        }
                    );
                }
            }
        }

        setVisibleUsersData((prev) => {
            const userCountMap: Record<string, number> = {};
            const updated = { ...prev };
            let hasChanged = false;

            Object.values(updated).forEach((userMark) => {
                const userId = userMark.user.userId;
                if (!userCountMap[userId]) userCountMap[userId] = 1;

                const index = userCountMap[userId];
                userCountMap[userId] += 1;

                // Solo modificamos si cambió
                if (userMark.index !== index) {
                    userMark = { ...userMark, index };
                    hasChanged = true;
                }

                const updatedPoints = userMark.points.map((point) => {
                    const [first, second] = point.extraData?.split('.') ?? ['0', '0'];
                    const newExtraData = `${first/* index */}${second ? `.${second}` : ''}`;
                    const coordKey = `${point.lat},${point.lng}`;
                    const newCount = countByCoordinates[coordKey];
                    if (point.extraData !== newExtraData) {
                        hasChanged = true;
                        return { ...point, extraData: newExtraData };
                    }
                    if (newCount !== undefined && point.count !== newCount/*  && newCount!==1 */ && [PointType.UNITY, PointType.UNITYT_START_END, PointType.UNITY_END, PointType.UNITY_START].includes(point.type)) {
                        hasChanged = true;
                        return { ...point, children: childrenByCoordinates[coordKey], count: newCount, type: newCount !== 1 ? PointType.UNITY : point.typeCopy };
                    }
                    return point;
                });

                userMark.points = updatedPoints;
                updated[userMark.user.id] = userMark;
            });

            return hasChanged ? updated : prev;
        });
    }, [visibleUsersData,]);
    /* useEffect(() => {

        setVisibleUsersData((prev) => {
            const userCountMap: Record<string, number> = {};
            const updated = { ...prev };
            let hasChanged = false;

            Object.values(updated).forEach((userMark) => {
                const userId = userMark.user.userId;
                if (!userCountMap[userId]) userCountMap[userId] = 1;

                const index = userCountMap[userId];
                userCountMap[userId] += 1;

                // Solo modificamos si cambió
                if (userMark.index !== index) {
                    userMark = { ...userMark, index };
                    hasChanged = true;
                }

                const updatedPoints = userMark.points.map((point) => {
                    const [, second] = point.extraData?.split('.') ?? ['0', '0'];
                    const newExtraData = `${index}${second ? `.${second}` : ''}`;
                    if (point.extraData !== newExtraData) {
                        hasChanged = true;
                        return { ...point, extraData: newExtraData };
                    }
                    return point;
                });

                userMark.points = updatedPoints;
                updated[userMark.user.id] = userMark;
            });

            return hasChanged ? updated : prev;
        });
    }, [visibleUsersData]); */

    const closeModal = () => {
        setModal({ description: '', open: false, title: '' })
    }
    const closeSnackbar = () => { setSnackbar(prev => ({ ...prev, open: false })) }
    const [allExpand, setAllExpand] = useState(false)
    const [arrayExpand, setArrayExpand] = useState<{
        id: string;
        clave: boolean;
    }[] | undefined>()

    const expandChild = (id: string, value: boolean) => {
        const nuevosDatos = arrayExpand?.map(item =>
            item.id == id ? { ...item, clave: value } : item
        );
        setArrayExpand(nuevosDatos)
    }

    const allAreTrue = useMemo(() => {
        return !!arrayExpand?.every(item => item.clave === true);
    }, [arrayExpand]);

    const allAreFalse = useMemo(() => {
        return !!arrayExpand?.every(item => item.clave === false);
    }, [arrayExpand]);

    const myActivities = async () => {
        loadingActivities()
        setLocalLoad(true)
        const response = await service.getActivities({ ids: ['all'], myActivity: true, query: returnQuery(filterMyActivity.filter.query) })
        const { types, total } = await service.getMyTypes({ id: local.id, query: returnQuery(filterMyActivity.filter.query) })
        setTypes(types)
        setTotalItems(total)
        SetData(response)
        setTotal(response?.total ?? 1)
        const visibleUserIds = Object.values(visibleUsersData).map(user => user.user.id);
        const nuevoArray = response.transform.myActivity?.activityList?.map(item => ({
            id: item.id,
            clave: allExpand // o false, dependiendo de tu lógica
        }));
        setArrayExpand(nuevoArray)

        const hiddenLocal = response?.transform?.userMark
            ?.filter(mark => !visibleUserIds.includes(mark.user.id))
            .map(mark => mark.user.id);
        const hiddenLocalCopy = response?.transform?.userMark
            .map(mark => mark.user.id);
        setHiddenLocale(isPagintaion ? hiddenLocal : hiddenLocalCopy);
        setHidenLocalCopy(hiddenLocalCopy);
        setLocalLoad(false)
    }

    const filterAll = () => {
        setVisibleUsersData({})
        filterUser.cleanFilter()
        setIsPagination(true)
    }

    const expasnded: Partial<IconButtonProps> = {
        color: 'primary',
        sx: {
            '& .MuiSvgIcon-root': {
                fontSize: '1rem',
            }
        },
        onClick: (e) => {
            e.stopPropagation();
            setAllExpand(!allExpand)
            const nuevosDatos = arrayExpand?.map(item => ({
                ...item,
                clave: !allExpand
            }));
            setArrayExpand(nuevosDatos);
        },
    };

    function isOnlyPaginationChanged(prevQuery: string, newQuery: string): boolean {
        const parseQuery = (query: string) => {
            return Object.fromEntries(new URLSearchParams(query));
        };

        const prevParams = parseQuery(prevQuery);
        const newParams = parseQuery(newQuery);

        const keysToIgnore = ['page', 'size'];

        // Compara todos los filtros excepto page y size
        for (const key in prevParams) {
            if (!keysToIgnore.includes(key) && prevParams[key] !== newParams[key]) {
                return false; // Algún filtro cambió
            }
        }

        for (const key in newParams) {
            if (!keysToIgnore.includes(key) && prevParams[key] !== newParams[key]) {
                return false; // Algún filtro cambió
            }
        }

        return true; // Solo cambió page o size
    }

    useEffect(() => {
        executeFunction({
            execute: () => {
                myActivities()
            }
        })
        setOldFilterString(filterMyActivity.filter.query.all ?? '')
        setIsPagination(isOnlyPaginationChanged(oldFilterString ?? '', filterMyActivity.filter.query.all ?? ''))
        if (!isOnlyPaginationChanged(oldFilterString ?? '', filterMyActivity.filter.query.all ?? '')) {
            setPage(1)
        }
    }, [filterMyActivity.filter.query.all])

    const changeExpandMap = () => {
        setExpandMap(prev => !prev)
    }

    useEffect(() => {
        if (allAreTrue) {
            setAllExpand(true)
        }
        if (allAreFalse) {
            setAllExpand(false)
        }
    }, [allAreTrue, allAreFalse])

    return (
        <>
            <Box sx={styles.mainContainer}>
                <Box sx={styles.containerUser(expandMap)}>
                    <Box sx={{ ...styles.alignHorizontal, ...styles.wFull } as SxProps}>
                        <Box sx={styles.header}>
                            <Typography variant="title_grey_big">{t('loogbook.titles.activityList')}</Typography>

                            <Box sx={styles.allButons}>
                                <Button sx={styles.seeButons} onClick={seeAll}>{t('loogbook.buttons.seeAll')}</Button>
                                <Button sx={styles.seeButons} onClick={hiddenAll}>{t('loogbook.buttons.hiddenAll')}</Button>
                                <CustomeIconButton title={t(`general.${!allExpand ? 'fullScreenOpen' : 'fullScreenExit'}`)} icon={icons(!allExpand ? 'fullScreenOpen' : 'closeFullScren')} iconButtonProps={expasnded} />
                                {!expandMap && <Button sx={styles.seeButons} onClick={changeExpandMap}>{expandMap ? t('loogbook.buttons.hiddenMap') : t('loogbook.buttons.seeMap')}</Button>}
                            </Box>
                        </Box>
                    </Box>

                    <CustomPaper elevation={2} sx={styles.paper}>
                        <MyActivityList
                            displayActivityListUsers={({ users }) => { displayHidden({ id: users }) }}
                            id="asdasd"
                            isVisible
                            list={[]}
                            assignData={myActivities}
                            listLocal={data?.transform.myActivity?.activityList ?? []}
                            localLoad={localLoad}
                            menuOption={goToActivityDetail}
                            userId=""
                            usersToDisplayed={hiddenLocal}
                            arrayExpand={arrayExpand}
                            expandChild={expandChild}
                            usersToView={[]}
                            //visibility={}
                            amount={totalItems}
                            title=""
                            types={types}
                            modelStore={data?.data?.items ?? []}
                        />
                        <Box sx={styles.footer}>
                            {!!(total > 1) &&
                                <Pagination
                                    page={page}
                                    sx={styles.pagination}
                                    count={total}
                                    onChange={(_, page) => {
                                        changePagination(page)
                                        setPage(page)
                                    }}
                                    showFirstButton
                                    showLastButton
                                />
                            }
                        </Box>
                    </CustomPaper>
                </Box>

                <Box sx={styles.map(expandMap)}>
                    <Box sx={styles.containerHidenButon}>
                        <Button sx={styles.seeButons} onClick={changeExpandMap}>{expandMap ? t('loogbook.buttons.hiddenMap') : t('loogbook.buttons.seeMap')}</Button>
                    </Box>
                    <Box sx={styles.containerMap}>
                        <ActivityMap
                            loadings={{ left: false, right: false }}
                            hiddenUsers={hiddenLocal}
                            usersMark={/* myActivity.usersMark */visibleUsersList}
                        />
                    </Box>
                </Box>

            </Box>


            <SimpleModal
                open={!!modal?.open}
                close={closeModal}
                title={modal?.title}
                description={modal?.description}
                cancelText={modal?.cancelText ?? t('general.cancel')}
                buttonText={modal?.confirmText ?? t('general.confirm')}
                back={modal?.cancel}
                isLoading={!!modal?.loading}
                loadingButton
                next={modal?.confirm ?? closeModal}
                sx={modal.sx}
                children={modal.children}
                removeButtons={modal.removeButtons}
            />
            <SnackSimple
                close={closeSnackbar}
                open={snackbar.open}
                type={snackbar.type}
                message={snackbar.message}
            />
            <FloatFilter
                cleanFilter={filterAll}
                counter={filterUser.counter}
                onChange={filterUser.onChange}
                values={filterUser.filterData}
                input={input}
                filter
            />

        </>
    )
}